import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Box, styled, Card } from '@mui/material';
import Button, { type ButtonProps } from '@mui/material/Button';
import styles from './login.module.scss';
import commonStyles from '../../App.module.scss';
import { object, string, ref, ValidationError } from 'yup';
import { CustomInputLabel, CustomRequiredInputLabel } from '../common/StyledComponents/StyledFields';
import { apiRequest, catchErrorMessageHandler, checkAuthToken, getaccessToken } from '../../infrastructure/backendService';
import { loginScreen } from './login';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import constants from "../../config/constants.json";
import ToastSuccess from '../common/toast/toastSuccess';
import ToastError from '../common/toast/toastError';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import apiPath from '../../config/apiPaths.json';
import { isNil } from 'lodash';
import LOCALE from '../../config/en-us.json';
import SuccessPopup from '../devotee/donation/successPopup';
import ErrorPopup from '../common/ErrorPopup';
import infoIcon from "../../assets/svg/info_icon.svg";



interface changePasswordProps {
   handleClickDonation?: () => void
   setOpen?: React.Dispatch<React.SetStateAction<boolean>>
}

export const CustomTextField = styled(TextField)`
   & input {
      padding: 8px;
      width: 100%;
      border-radius: 8px;
      background: #fff9e4;
      height: 29px;
   }
   & fieldset {
      border-style: unset;
   }
`;

interface UserForm {
   oldpassword: string;
   newpassword: string;
   renternewpassword: string;
   // secretQuestion: string,
   // secretAnswer: string,
   // confirmanswertosecretquesstion: string;
}

type ErrorMessageTypes = {
   oldpassword: string;
   newpassword: string;
   renternewpassword: string;
   // secretQuestion: string,
   // secretAnswer: string,
   // confirmanswertosecretquesstion: string;
};

export default function ChangePassword(props: changePasswordProps) {
   const [showPasswordInfo, setShow] = useState(false);
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const [showPassword, setShowPassword] = useState(false);
   const [showoldPassword, setShowoldPassword] = useState(false);
   const [showReenterPassword, setReenterpassword] = useState(false);
   const [userForm, setUserForm] = useState<UserForm>({
      oldpassword: '',
      newpassword: '',
      renternewpassword: '',
      // secretQuestion: '',
      // secretAnswer: '',
      // confirmanswertosecretquesstion: ''
   });
   const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
      oldpassword: '',
      newpassword: '',
      renternewpassword: '',
      // secretQuestion: '',
      // secretAnswer: '',
      // confirmanswertosecretquesstion: ''
   });

   const navigate = useNavigate();

   const handleClickShowPassword = () => setShowPassword((show) => !show);
   const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
   };
   const handleClickShowoldPassword = () => setShowoldPassword((show) => !show);
   const handleMouseDownoldPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
   };
   const handleClickShowRenterPassword = () => setReenterpassword((show) => !show);
   const handleMouseDownReenterPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
   };

   useEffect(() => {
      if (!checkAuthToken()) {
         navigate('/');
      }
   }, [getaccessToken()]);

   const handleFieldChange = (field: any, value: any): void => {
      setUserForm({
         ...userForm,
         [field]: value,
      });
   };
   const logoutUser = () => {
      sessionStorage.clear();
      window.location.reload();
      navigate('/');
   };

   const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@`#^_$!%*?&])[A-Za-z\d@`#^_$!%*?&]{9,16}$/;
   const validationSchema = object().shape({
      oldpassword: string().required('Old Password is required'),
      newpassword: string()
      .notOneOf([ref('oldpassword'), ''], 'New Password should not be the same as Old Password')
      .min(9, "Password must be at least 9 characters")
      .max(16, "Password must be no more than 16 characters")
      .required("Password is required")
      .test(
        'password-complexity',
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
        (value) => {
          const uppercaseRegex = /[A-Z]/;
          const lowercaseRegex = /[a-z]/;
          const numberRegex = /[0-9]/;
          const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

          let errors = [];

          if (!uppercaseRegex.test(value)) {
            errors.push('uppercase letter');
          }
          if (!lowercaseRegex.test(value)) {
            errors.push('lowercase letter');
          }
          if (!numberRegex.test(value)) {
            errors.push('number');
          }
          if (!specialCharRegex.test(value)) {
            errors.push('special character');
          }

          if (errors.length > 0) {
            return new ValidationError(
              `Password must contain at least one ${errors.join(', ')}.`,
              null,
              'newpassword'
            );
          }

          return true;
        }
      ),
      renternewpassword: string()
        .required('Re-Enter New Password is required')
        .oneOf([ref('newpassword'), ''], 'New Password and Re-Enter Password must match'),
    });

   const submitApiCall = () => {
      const reqBody = {
         oldPassword: userForm.oldpassword,
         newPassword: userForm.newpassword,
         confirmNewPassword: userForm.renternewpassword,
         //  username: '002TEM',
         username: sessionStorage.getItem('username')
         // relation:formData.
         // added required parameters
      };
      apiRequest({
         method: 'POST',
         endpoint: apiPath.changePassword,
         body: JSON.stringify(reqBody),
         includeToken: true,
      })
         .then((res) => {
            console.log(res, 'resssssssssssss');
            const successMessage = LOCALE.PASSWORD_CHANGED;
            // toast.custom(<ToastSuccess sent="Success" message={successMessage} />, {
            //    duration: 10000
            // })
            toast.custom(<SuccessPopup headerMessage="Change Password" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            });
            props.setOpen?.(false);

            logoutUser();
         })
         .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   };

   const handleCancel = () => {
      setUserForm({
         oldpassword: '',
         newpassword: '',
         renternewpassword: '',
         // secretQuestion: '',
         // secretAnswer: '',
         // confirmanswertosecretquesstion: ''
      });
   };

   const handleSubmit = async (): Promise<void> => {
      const errors: ErrorMessageTypes = {
         oldpassword: '',
         newpassword: '',
         renternewpassword: '',
         // secretQuestion: '',
         // secretAnswer: '',
         // confirmanswertosecretquesstion: ''
      };
      try {
         // Validate the form data against the validation schema
         await validationSchema.validate(userForm, { abortEarly: false });
         // If validation passes, you can submit the form
         setErrorMessage(errors);

         // Call your API or perform other actions here
         submitApiCall();
      } catch (error: any) {
         // Handle validation errors

         if (error instanceof ValidationError) {
            error.inner.forEach((e: any) => {
               if (e.path) {
                  errors[e.path as keyof ErrorMessageTypes] = e.message;
               }
            });
         }
         setErrorMessage(errors);
      }
   };

   const userNameField = (): React.ReactElement => {
      // const validatePasswordLength = (password: string) => {
      //    const maxLength = 12;
      //    if (password.length > maxLength) {
      //       return `Password must be between  6 to ${maxLength} characters.`;
      //    }
      //    return '';
      // };
      return (
         <>
            <Box className={styles.Form}>
               {/* <Grid container spacing={2} sx={{ marginTop: '0px' }}> */}

               <Grid xs={12} item sx={{ paddingBottom: "16px" }}>
                  {CustomRequiredInputLabel("Old Password", true)}
                  <CustomTextField sx={{ background: "#fff9e4" }}
                     fullWidth={true}
                     required={true}
                     value={userForm.oldpassword}
                     onChange={(e) => {
                        const newPassword = e.target.value;
                        // const validationError = validatePasswordLength(newPassword);

                        // if (validationError) {
                        //    setErrorMessage({ ...errorMessage, oldpassword: validationError });
                        // } else {
                           setErrorMessage({ ...errorMessage, oldpassword: '' });
                           handleFieldChange("oldpassword", newPassword);
                        // }
                     }}

                     type={showoldPassword ? 'text' : 'password'}
                     InputProps={{
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowoldPassword}
                                 onMouseDown={handleMouseDownoldPassword}
                                 edge="end"
                              >
                                 {showoldPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     className={errorMessage.oldpassword ? styles.errorTextField : styles.textField}
                  />
                  {errorMessage.oldpassword ? (
                     <Typography sx={{ color: 'red', fontSize: '12px' }}>
                        {errorMessage.oldpassword}
                     </Typography>
                  ) : (
                     ''
                  )}
               </Grid>
               {/* </Grid> */}

               <Grid xs={12} item sx={{ paddingBottom: "16px" }}>
                  {CustomRequiredInputLabel("New Password", true)}
                  <CustomTextField sx={{ background: "#fff9e4" }}
                     fullWidth={true}
                     required={true}
                     value={userForm.newpassword}
                     type={showPassword ? 'text' : 'password'}
                     onChange={(e) => {
                        const newPassword = e.target.value;
                        // const validationError = validatePasswordLength(newPassword);

                        // if (validationError) {
                        //    setErrorMessage({ ...errorMessage, newpassword: validationError });
                        // } else {
                           setErrorMessage({ ...errorMessage, newpassword: '' });
                           handleFieldChange("newpassword", newPassword);
                        // }
                     }}
                     InputProps={{
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowPassword}
                                 onMouseDown={handleMouseDownPassword}
                                 edge="end"
                              >
                                 {showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     className={errorMessage.newpassword ? styles.errorTextField : styles.textField}
                  />
                  {errorMessage.newpassword ? (
                     <Typography sx={{ color: 'red', fontSize: '12px' }}>
                        {errorMessage.newpassword}
                     </Typography>
                  ) : (
                     ''
                  )}
               </Grid>
               <Grid xs={12} item sx={{ paddingBottom: "16px" }}>
                  {CustomRequiredInputLabel("Re- Enter New Password", true)}
                  <CustomTextField sx={{ background: "#fff9e4" }}
                     fullWidth={true}
                     required={true}
                     value={userForm.renternewpassword}
                     type={showReenterPassword ? 'text' : 'password'}
                     onChange={(e) => {
                        const newPassword = e.target.value;
                        // const validationError = validatePasswordLength(newPassword);
                        // if (validationError) {
                        //    setErrorMessage({ ...errorMessage, renternewpassword: validationError });
                        // } else {
                           setErrorMessage({ ...errorMessage, renternewpassword: '' });
                           handleFieldChange("renternewpassword", newPassword);
                        // }
                     }}
                     InputProps={{
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowRenterPassword}
                                 onMouseDown={handleMouseDownReenterPassword}
                                 edge="end"
                              >
                                 {showReenterPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     className={errorMessage.renternewpassword ? styles.errorTextField : styles.textField}
                  />
                  {errorMessage.renternewpassword ? (
                     <Typography sx={{ color: 'red', fontSize: '12px' }}>
                        {errorMessage.renternewpassword}
                     </Typography>
                  ) : (
                     ''
                  )}
               </Grid>
               <Grid xs={12} item sx={{ marginTop: '20px' }}>
                  <Button
                     color="warning"
                     fullWidth={true}
                     variant="contained"
                     onClick={handleSubmit}
                  >
                     Submit
                  </Button>
                  <Button
                     color="warning"
                     fullWidth={true}
                     variant="outlined"
                     onClick={handleCancel}
                     sx={{ marginTop: '20px' }}
                  >
                     Cancel
                  </Button>
               </Grid>
               <Card className={commonStyles.passwordHints}>
                  <ul>
                     <li>{LOCALE.PASSWORD_HINT_ONE }</li>
                     <li>{LOCALE.PASSWORD_HINT_TWO}</li>
                  </ul>
               </Card>
            </Box>
         </>
      );
   };

   const userFields = (): React.ReactElement => {
      return (
         <>
            <Box sx={{ marginTop: '10px' }}>
               {/* <Typography variant="h4" component="h4" align="left">
                        Login
                    </Typography> */}
               <Typography align="left" sx={{ fontSize: '24px', paddingBottom: '24px' }}>
                  Change Password
               </Typography>
             </Box>
            {userNameField()}
         </>
      );
   };

   return <div className={styles.changePasswordSection}>{userFields()}</div>;
}
